/* istanbul ignore file */
export enum MapPinStyles {
    Default = 1,
    Custom = 2
}
